import { render, staticRenderFns } from "./HomeSchoolSection.vue?vue&type=template&id=3010c002&"
import script from "./HomeSchoolSection.vue?vue&type=script&lang=js&"
export * from "./HomeSchoolSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports